import React from "react";
import { colorForText } from "../utilities/colorutils";

const BrandLogo = ({ brand }: { brand: server.dto.BrandSmall, boxWhenNoImage?: boolean }) => {

  if (brand.logoUrl) return (<div className="brand-info-panel-logo"><img src={brand.logoUrl} title={brand.name} /></div>);

  const backgroundColor = colorForText(brand.name, 0.9);

  return (<div className="flex align-center justify-center" style={{
    textAlign: "center",
    backgroundColor,
    padding: "10px 15px",
    fontSize: "2.5rem",
    lineHeight: "1.2em",
    fontWeight: 500,
    color: "white"
  }} title={brand.name}>{brand.name}</div>);
};

export default BrandLogo;